// extracted by mini-css-extract-plugin
export var aircallIframe = "_iy-3";
export var fabContainer = "_iy-5";
export var fabRinging = "_iy-6";
export var loadingOverlay = "_iy-4";
export var pulse = "_iy-7";
export var widgetContent = "_iy-2";
export var widgetPanel = "_iy-0";
export var widgetPanelExpanded = "_iy-1";